import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';


import { DatePipe } from '@angular/common';
import { GalleryGroup } from 'src/app/Models/gallarygroupmaster';
import { Gallery } from 'src/app/Models/gallerymaster';
import { ApiService } from 'src/app/Service/api.service';


@Component({
  selector: 'app-gallerymaster',
  templateUrl: './gallerymaster.component.html',
  styleUrls: ['./gallerymaster.component.css'],
  providers: [DatePipe]
})
export class GallerymasterComponent implements OnInit {

  @Input() drawerClose: Function;
  @Input() data: Gallery;
  isokfile:boolean
    isSpinning = false
  logtext:string = "";
  group_id = 0
  groupName = "None"
  loadingGroups= false;
  dataList=[]

  //instructors:Instructor[];
  groups:GalleryGroup[]




 date = new Date();
 date1 = this.datePipe.transform(this.date, 'yyyyMMdd')
fileDataIMAGE_URL:File=null
 folderName= "GalleryImages"
  constructor(private api: ApiService, private message: NzNotificationService,private datePipe:DatePipe) {
  }

  ngOnInit() {
    this.loadAllGroups()
    this.AllGroup()
  
  }
  loadAllGroups(data?) {
    //console.log(data)
    //console.log(this.data.ID)
    
 
    
    this.loadingGroups = true
   // console.log(filter)
    this.api.getAllGalleryGroup(0, 0, "ID", "desc", " AND STATUS=1").subscribe(data => {
      console.log("Group data")
      console.log(data);
      this.groups = data['data'];
      this.loadingGroups = false
      

    }, err => {
      console.log(err);
    });
  }
  AllGroup() {
   
    this.api.getAllGallery(0, 0, "ID", "desc", " AND STATUS=1").subscribe(data => {
      console.log("INstructor  data")
      console.log(data);
      this.data = data['data'];
      this.dataList = data['data'];
      //this.loadingContents = false
      //this.data.SEQUENCE_NUMBER=this.dataList[0]['SEQUENCE_NUMBER']
      //   console.log("seq data",this.drawerData.SEQUENCE_NUMBER)
//this.data.SEQUENCE_NUMBER=Number( this.dataList[0]['SEQUENCE_NUMBER'])+1
      //   console.log("seq data1",this.drawerData.SEQUENCE_NUMBER)
     this.loadingGroups = false
      

    }, err => {
      console.log(err);
    });
  }

  close(): void {
    this.drawerClose();

	this.logtext = 'CLOSED - Gallery form';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

  }

  save(addNew: boolean): void {
    var isOk = true
    if (this.data.GROUP_ID == undefined || this.data.GROUP_ID==0) {
      this.message.error("Please Enter Group Name" , "");
      isOk = false
    }
    if (this.data.NAME == undefined || this.data.NAME=="") {
      this.message.error("Please Enter  Name" , "");
      isOk = false
    }
    if (this.data.SEQUENCE_NO == undefined || this.data.SEQUENCE_NO==0) {
      this.message.error("Please Enter Sequence No." , "");
      isOk = false
    }
    if(isOk){

    this.isSpinning = true;
  
      if (this.data.ID) {

	 if (this.fileDataIMAGE_URL) {
 if (this.data.IMAGE_URL == "") {
  this.data.IMAGE_URL = this.genarateKeyIMAGE_URL();
}
   else {
 var str = this.data.IMAGE_URL.substring(this.data.IMAGE_URL.lastIndexOf('/') + 1).split('.')
    var fileExt = this.fileDataIMAGE_URL.name.split('.').pop();
  var url = str[0] + "." + fileExt;
   this.api.onUpload(this.folderName, this.fileDataIMAGE_URL, url)
  // this.data.IMAGE_URL = this.api.retriveimgUrl + this.folderName + "/" + url;
  this.data.IMAGE_URL =url

 }
  }
 else { 
 this.data.IMAGE_URL = ""
  }

        this.api.updateGallery(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.data.IMAGE_URL=null
              this.message.success("Gallery information updated Successfully...", "");

	this.logtext = 'Update & Close - Gallery form - SUCCESS '+ JSON.stringify(this.data)+" KEYWORD [U - Gallery ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              if (!addNew)
                this.drawerClose();
              this.isSpinning = false;
            }
            else {

	this.logtext = 'Update & Close - Gallery form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [U - Gallery ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              this.message.error("Failed to update gallery information...", "");
              this.isSpinning = false;
            }
          });
      }
      else {
 if (this.fileDataIMAGE_URL) {
 this.data.IMAGE_URL = this.genarateKeyIMAGE_URL()
}
  else {
  this.data.IMAGE_URL = "";
 }
 console.log("me")
console.log(this.data)
        this.api.createGallery(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.data.IMAGE_URL=null
              this.message.success("Gallery information added successfully...", "");

              if (!addNew)
	{
                this.drawerClose();

	this.logtext = 'Save & Close - Gallery form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Gallery ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
	}

              else {
                this.data = new Gallery();
	this.logtext = 'Save & New - Gallery form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Gallery ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              }
              this.isSpinning = false;
            }
            else {
              this.message.error("Failed to add gallery information...", "");
	this.isSpinning = false;
	this.logtext = 'Save & Close - Gallery form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [C - Gallery ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
              
            }
          });
      }
  }
}

 genarateKeyIMAGE_URL() {
 var number = Math.floor(100000 + Math.random() * 900000)  
var fileExt = this.fileDataIMAGE_URL.name.split('.').pop();
 var url = this.date1 + number + "." + fileExt
  this.api.onUpload(this.folderName, this.fileDataIMAGE_URL, url)
  // this.data.IMAGE_URL = this.api.retriveimgUrl + this.folderName + "/" + url;
  this.data.IMAGE_URL =url
  return this.data.IMAGE_URL
} 
onFileSelectedIMAGE_URL(event) {
  {
    this.isokfile = true
    const allowed_types = ['image/png', 'image/jpeg', 'image/jpg'];
    if (!allowed_types.toString().match(event.target.files[0].type)) {
      this.isokfile = false
      this.message.error("Only PNG Images are allowed ", "");
    }

    if (this.isokfile) {
      this.fileDataIMAGE_URL = <File>event.target.files[0];
    }

  }


}
clear() {
  this.fileDataIMAGE_URL = null
}
}